export default function SVG_Fill() {
  return (
    <div>
      <h1>SVG_Fill Component</h1>
    </div>
  );
}
